import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#3d9be9",
      contrastText: "#FFF",
    },
    secondary: {
      main: "#ED5565",
      contrastText: "#FFF",
    },
  },
});

export default theme;
